import React from 'react';
import { Page } from '../Page';
import { Zap, Droplet, Award } from 'lucide-react';
export function SupplementWheyProtein() {
  return <Page pageNumber={10} variant="light" data-id="element-3405">
      <div className="flex h-full gap-10" data-id="element-3406">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3407">
          <img src="https://cdn.magicpatterns.com/uploads/rz95qpTVrA12dEB643rF4b/pasted-image.png" alt="Thorne Whey Protein Isolate" className="w-full max-w-[280px] object-contain" data-id="element-3408" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3409">
          <div className="mb-6 pt-4" data-id="element-3410">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3411">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3412">
              Whey Protein Isolate
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3413">
              Hit your protein goals when appetite is low
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3414" />
          </div>

          <div className="mb-8" data-id="element-3415">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3416">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3417">
              When appetite is suppressed and portions are small, a high-quality
              protein shake is often the most practical way to hit 80-100g+
              daily targets. At 21g protein per scoop in just 100 calories, this
              is an extremely efficient protein-to-calorie ratio.
            </p>
          </div>

          <div className="mb-8" data-id="element-3418">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3419">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3420">
              <li className="flex gap-2" data-id="element-3421">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3422" />
                <span data-id="element-3423">
                  Preserves lean mass during weight loss with complete amino
                  acid profile
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3424">
                <Droplet className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3425" />
                <span data-id="element-3426">
                  Includes bromelain + papain digestive enzymes (helpful for
                  GLP-1 users with slowed digestion)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3427">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3428" />
                <span data-id="element-3429">
                  Whey isolate = easier digestion, lower lactose, NSF Certified
                  for Sport
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3430">
                <span className="text-tealslate shrink-0" data-id="element-3431">•</span>
                <span data-id="element-3432">
                  Easy to consume when solid food feels difficult. Mix with
                  water, milk, or smoothies
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3433">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3434">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3435">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3436">
                <strong data-id="element-3437">1 scoop (30.2g)</strong> with at least 8oz liquid daily
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3438">
                ~30 servings per 906g tub • 21g protein, 100 calories per
                serving
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3439">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3440" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3441">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}